//Constants for MainComponents

//Constants for Navbar.jsx
export const HOME = "Accueil";
export const ABOUT_ME = "À propos de moi";
export const WORKING_EXPERIENCES = "Expériences professionnelles";
export const PROJECTS = "Projets";
export const ACADEMIC_PROJECTS = "Projets académiques";
export const PERSONAL_PROJECTS = "Projets personnels";
export const ART_GALLERY = "Galerie d'art";
export const PHOTO_GALLERY = "Galerie de photo";
export const EDUCATION = "Éducation";
export const CONTACT = "Contact";

//Constants for Footer.jsx
export const FOOTER_TITLE = "Restons en contact!";
export const LINKEDIN = "LinkedIn";
export const GITHUB = "Github";
export const COPYRIGHT = "Droit d'auteur";
export const ALL_RIGHTS_RESERVED = "The Minh Luong - TOUS DROITS RÉSERVÉS";
export const PORTFOLIO_START_YEAR = "2021-";

//Constants for NotFound.jsx
export const ERROR_404 = "404";
export const ERROR_MESSAGE = "Oups! On dirait que nous avons atteint une impasse. Reprenons le bon chemin.";
export const NAVIGATE_BACK = "Naviguez de retour à la page d'accueil pour continuer votre exploration";
export const HINTS = "Vous pouvez toujours utiliser le bouton retour ou la barre de navigation pour revenir à la page d'accueil.";
export const SEE_YOU = "À bientôt!";
